import { isPlatformBrowser } from '@angular/common';
import { Component, EventEmitter, Inject, Input, Output, PLATFORM_ID, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { Select2Data } from 'ng-select2-component';
import { ToastrService } from 'ngx-toastr';
import { Observable, lastValueFrom } from 'rxjs';
import { Province, District, Ward, ProvinceV2 } from '../../interface/province.interface';
import { DeliveryAddress, StatusAddress } from '../../interface/user.interface';
import { AddressService } from '../../services/address.service';
import { CommonService } from '../../services/common.service';
import { ProvinceService } from '../../services/province.service';

@Component({
  selector: 'app-addressv2-modal',
  templateUrl: './addressv2-modal.component.html',
  styleUrl: './addressv2-modal.component.scss'
})
export class Addressv2ModalComponent {
  @Input() address: DeliveryAddress | undefined;

  @Output() resultForm = new EventEmitter<DeliveryAddress>();
  @Output() resetAddress = new EventEmitter();

  public idaddress: string;
  public typeModal: number = 0;
  public form: FormGroup;
  public closeResult: string;
  public modalOpen: boolean = false;
  public states$: Observable<Select2Data>;
  @ViewChild('addressV2Modal', { static: false })
  AddressV2Modal: TemplateRef<string>;
  public province: ProvinceV2;
  public provinceCode: number = 0;
  public districtCode: number = 0;
  public selectedProvince: number;
  public selectedDistrict: number;
  public selectedWard: number;
  public checkDefault: boolean = false;
  public provinces: ProvinceV2[] = [];
  public districts: District[] = [];
  public wards: Ward[] = [];
  public bodyCreateAddress: DeliveryAddress;

  select2Provinces: any;
  select2Wards: any;

  loadingDistricts: boolean = false;
  loadingWards: boolean = false;

  constructor(
    private modalService: NgbModal,
    @Inject(PLATFORM_ID) private platformId: Object,
    private formBuilder: FormBuilder,
    private provinceService: ProvinceService,
    private addressService: AddressService,
    private toastr: ToastrService
  ) {
    this.form = this.formBuilder.group({
      name: new FormControl('', [Validators.required]),
      province: new FormControl('', [Validators.required]),
      ward: new FormControl('', [Validators.required]),
      address: new FormControl('', [Validators.required]),
      phone: new FormControl('', [
        Validators.required,
        Validators.maxLength(10),
        Validators.minLength(10),
      ]),
    });
  }

  async ngOnInit() {
    await this.getProvincesInfo();
    if (this.address && this.address.provinceV2) {
      this.province = this.address.provinceV2;
    }
  }

  async ngOnChanges() {
    // this.form.reset();
    if (this.address && this.address.provinceV2) {
      this.typeModal = 1;
      this.form.patchValue({
        name: this.address.receiverName?.toString(),
        province: this.address.provinceV2.code?.toString(),
        ward: this.address.provinceV2.wards[0]?.code?.toString(),
        address: this.address.address?.toString(),
        phone: this.address.receiverPhone?.toString(),
      });
      this.idaddress = this.address.id;
      this.loadWardsByProvince({ value: this.address.provinceV2.code ?? 0 });

      this.checkDefault = this.address.status == 0 ? true : false;
    } else {
      this.typeModal = 0;
      this.resetForm();
    }
  }

  @Input() addresses: DeliveryAddress[] = [];

  async getProvincesInfo() {
    //call api get provinces
    this.provinceService.getProvinceV2InfoByRegion().subscribe({
      next: (res: ProvinceV2[]) => {
        this.provinces = res;
        this.select2Provinces = this.provinces.map(
          (province: ProvinceV2) =>
            new Object({
              value: province.code,
              label: province.name,
            })
        );
      }
    })
  }

  setSelect2WardData() {
    this.select2Wards = this.wards.map(
      (ward: Ward) =>
        new Object({
          value: ward.code,
          label: ward.name,
        })
    );
  }

  loadWardsByProvince($event: any) {
    if ($event.value && !this.loadingWards && this.selectedProvince != $event.value) {
      this.loadingWards = true;
      this.provinceService.getProvinceV2InfoByDepth($event.value, 0).subscribe({
        next: (res: ProvinceV2[]) => {
          this.wards = res[0].wards;
          this.selectedProvince = $event.value;
          this.setSelect2WardData();
          this.selectedWard = this.address?.provinceV2?.wards[0].code ?? 0;
          this.province = res[0];
        },
        error: (err: any) => {
          console.error(err);
          this.loadingWards = false;
        },
        complete: () => {
          this.loadingWards = false;
        }
      })
    }
  }

  onSelectWard($event: any) {
    if ($event.value && this.selectedWard != $event.value) {
      this.selectedWard = $event.value;
    }
  }

  resetForm() {
    this.form.reset();
    this.select2Wards = [];
    this.selectedProvince = 0;
    this.selectedDistrict = 0;
    this.selectedWard = 0;
  }

  //open modal
  async openModal() {
    if (isPlatformBrowser(this.platformId)) {
      // For SSR
      this.modalOpen = true;
      this.modalService
        .open(this.AddressV2Modal, {
          ariaLabelledBy: 'address-add-Modal',
          centered: true,
          windowClass: 'theme-modal  modal-lg',
        })
        .result.then(
          (result) => {
            `Result ${result}`;
          },
          (reason) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
          }
        );
    }
  }

  private getDismissReason(reason: ModalDismissReasons): string {
    if (this.typeModal == 0) {
      this.resetForm();
    }
    else {
      this.resetAddress.emit();
    }

    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  async submit() {
    this.form.markAllAsTouched();

    if (this.form.valid) {
      // check valid form
      this.bodyCreateAddress = new DeliveryAddress();

      let province = { ...this.province } as ProvinceV2;
      province.wards = province.wards.filter(p => p.code == this.selectedWard);

      this.bodyCreateAddress.address = this.form.get('address')?.value;
      this.bodyCreateAddress.receiverName = this.form.get('name')?.value;
      this.bodyCreateAddress.receiverPhone = this.form.get('phone')?.value.toString();
      this.bodyCreateAddress.provinceV2 = province;
      this.bodyCreateAddress.id = this.idaddress;
      this.bodyCreateAddress.status = this.checkDefault ? 0 : 1;

      //check if address is default and there is no default address
      if (
        this.addresses.length < 1 &&
        !this.checkDefault &&
        this.typeModal == 1
      ) {
        this.toastr.warning('Phải có ít nhất 1 địa chỉ mặc định !', '', {
          positionClass: 'toast-top-right',
        });
        return;
      }
      if (!this.checkDefault && this.typeModal == 1) {
        const foundAddress = this.addresses.find(
          (address) => address.id === this.bodyCreateAddress.id
        );
        if (foundAddress) {
          foundAddress.status = StatusAddress.Active;
          const countStatusOne = this.addresses.filter(
            (address) => address.status === 0
          ).length;
          if (countStatusOne === 0) {
            foundAddress.status = StatusAddress.Default;
            this.checkDefault = true;
            this.toastr.warning('Phải có ít nhất 1 địa chỉ mặc định !', '', {
              positionClass: 'toast-top-right',
            });
            return;
          }
        }
      }

      if (this.typeModal == 1) {
        this.addressService
          .updateUserAddress(JSON.stringify(this.bodyCreateAddress))
          .subscribe((res) => {
            if (res) {
              this.toastr.success('Cập nhật địa chỉ thành công', '', {
                positionClass: 'toast-top-right',
              });
              this.resultForm.emit(this.bodyCreateAddress);
              this.form.reset();
            } else {
              this.toastr.error('Cập nhật địa chỉ thất bại', '', {
                positionClass: 'toast-top-right',
              });
            }
          });
      } else {
        this.addressService
          .createUserAddress(JSON.stringify(this.bodyCreateAddress))
          .subscribe((res) => {
            if (res) {
              this.toastr.success('Thêm địa chỉ thành công', '', {
                positionClass: 'toast-top-right',
              });
              this.resultForm.emit(this.bodyCreateAddress);
              this.form.reset();
            }
          });
      }

      this.modalService.dismissAll();
      this.modalOpen = false;
    }
  }

  changeDefaultAddress(event: any) {
    if (event.target.checked) {
      this.checkDefault = true;
      this.bodyCreateAddress.status = 0;
    } else {
      this.checkDefault = false;
      this.bodyCreateAddress.status = 1;
    }
  }

  ngOnDestroy() {
    if (this.modalOpen) {
      this.modalService.dismissAll();
    }
  }
}
